import { SET_PLAN_DATA } from '../types/types';

export const setPlanData = (value) => {
  return {
    type: SET_PLAN_DATA,
    payload: { data: value },
  };
};
